// Import Swiper core and required modules instead of full bundle
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Thumbs,
    Autoplay,
    FreeMode,
} from 'swiper/modules';
import $ from 'jquery';

/* ===============================================================
  Swiper Init
=============================================================== */
class SwiperJs {
    constructor() {
        this.events();
        this.thumbSwiper;
        this.heroSwiper;
    }

    // Event =============================================================================
    events() {
        let current = this;
        $(document).on('DOMContentLoaded', function () {
            if ($('.single-gallery-overlay, .single-gallery').length) {
                current.gallerySingleClickable();
            }
            if ($('.post-single-advanced .related-post-slider').length) {
                current.swiperRelatedPosts();
            }
            if ($('.irantheme-myaccount-dashboard-banner-slider').length) {
                current.swiperMyAccountDashboardSlider();
            }
            if ($('.irantheme-business-authors-post-swiper').length) {
                current.swiperBusinessAuthorsPost();
            }
            if ($('.irantheme-woocommerce-products-post-swiper').length) {
                current.swiperWoocommerceProducts();
            }
            if ($('.irantheme-woocommerce-grid-products-swiper').length) {
                current.swiperWoocommerceGridProducts();
            }
            if ($('.irantheme-woocommerce-categories-post-swiper').length) {
                current.swiperWoocommerceCategories();
            }
            if ($('.irantheme-woocommerce-box-categories-post-swiper').length) {
                current.swiperWoocommerceBoxCategories();
            }
            if ($('.irantheme-woocommerce-box-brands-post-swiper').length) {
                current.swiperWoocommerceBoxBrands();
            }
            if ($('.irantheme-woocommerce-slider-product-swiper').length) {
                current.swiperWoocommerceSliderProduct();
            }
            if ($('.irantheme-business-box-reviews-post-swiper').length) {
                current.swiperBusinessBoxReviews();
            }
            if ($('.irantheme-business-brands-post-swiper').length) {
                current.swiperBusinessBrands();
            }
            if ($('.irantheme-gallery-social-post-swiper').length) {
                current.swiperGallerySocial();
            }
            // if ($('.irantheme-gallery-social-fixed-swiper').length) {
            //     current.swiperGallerySocialFixed();
            // }
            if ($('.irantheme-section-service-note-slider-swiper').length) {
                current.swiperServiceNoteSlider();
            }
            if ($('.irantheme-post-gallery-carousel-swiper').length) {
                current.swiperPostGalleryCarousel();
            }
            if ($('.irantheme-post-sidebar-slider-swiper').length) {
                current.swiperPostSidebarSlider();
            }
            if ($('.irantheme-blog-post-carousel-swiper').length) {
                current.swiperBlogPostCarousel();
            }
            if ($('.comments-swiper').length) {
                current.swiperCommentsSlider();
            }
            if ($('.irantheme-login-image-carousel').length) {
                current.swiperLoginImageCarousel();
            }
            if ($('.irantheme-business-viewpoints-post-swiper').length) {
                current.swiperBusinessViewpoints();
            }
            if ($('.product-image-wrapper').length) {
                current.woocommerceSingleProductGallery();
                // Get product gallery layout for fix direction of thumb slider (This is for single product)
                let singleProductGalleryLayout = $(
                    '.product-image-wrapper',
                ).data('layout');
                $(window).on('resize', function () {
                    if (singleProductGalleryLayout == 'thumb-slider-vertical') {
                        // Call ReInit function for fix direction of thumb slider
                        current.woocommerceSingleProductGalleryReInit();
                    }
                });
            }
            // Gallery master
            if ($('.irantheme-gallery-magnification-slider')) {
                current.magnificationMediaGalleryItem();
            }
        });
    }

    swiperCommentsSlider() {
        let current = this;
        let breakpoints = current.generateBreakpointsForSwiper(3, 1);
        // Slider latest comments
        let commentSlider = new Swiper('.comments-swiper', {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            slidesPerView: 3,
            spaceBetween: 30,
            freeMode: true,
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            // centeredSlides: true,
            // grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints,
        });
    }

    swiperPostSidebarSlider() {
        let current = this;
        // Post sidebar (Init section swiper slider)
        jQuery('.irantheme-post-sidebar-slider-swiper').each(
            function (index, element) {
                let autoplayStatus = jQuery(element).data('autoplay-status');
                let autoplayDelay = jQuery(element).data('autoplay-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperPostSidebarSlider = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: 1,
                            spaceBetween: 30,
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperLoginImageCarousel() {
        let current = this;
        // Post Gallery Carousel post (Init section swiper slider)
        jQuery('.irantheme-login-image-carousel').each(
            function (index, element) {
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(1);
                var swiperLoginPageCarousel = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                        // dynamicBullets: true,
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true,
                    },
                    loop: true,
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperBlogPostCarousel() {
        let current = this;
        // Post Gallery Carousel post (Init section swiper slider)
        jQuery('.irantheme-blog-post-carousel-swiper').each(
            function (index, element) {
                let postBoxCarouselColumns = $(element).attr('data-columns');
                let postBoxCarouselCellsGap = $(element).attr('data-cell-gap');
                let breakpoints = current.generateBreakpointsForSwiper(
                    postBoxCarouselColumns,
                );
                var swiperPostBoxCarousel = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: postBoxCarouselColumns,
                    spaceBetween: postBoxCarouselCellsGap,
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperPostGalleryCarousel() {
        let current = this;
        // Post Gallery Carousel post (Init section swiper slider)
        jQuery('.irantheme-post-gallery-carousel-swiper').each(
            function (index, element) {
                let postGalleryCarouselColumns =
                    $(element).attr('data-columns');
                let postGalleryCarouselCellsGap =
                    $(element).attr('data-cell-gap');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    postGalleryCarouselColumns,
                    1,
                );
                var swiperPostGalleryCarousel = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: postGalleryCarouselColumns,
                    spaceBetween: postGalleryCarouselCellsGap,
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperServiceNoteSlider() {
        let current = this;
        // Business brands items (Init section swiper slider)
        jQuery('.irantheme-section-service-note-slider-swiper').each(
            function (index, element) {
                let businessBrandsItemsColumns = 1;
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    businessBrandsItemsColumns,
                    1,
                );
                var swiperBusinessBrands = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: businessBrandsItemsColumns,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: $(element).find(
                            '.irantheme-section-service-note-slider-swiper-next',
                        )[0],
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperBusinessBrands() {
        let current = this;
        // Business brands items (Init section swiper slider)
        jQuery('.irantheme-business-brands-post-swiper').each(
            function (index, element) {
                let businessBrandsItemsColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    businessBrandsItemsColumns,
                );
                var swiperBusinessBrands = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: businessBrandsItemsColumns,
                    spaceBetween: 60,
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false,
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperGallerySocial() {
        let current = this;
        // Gallery social items (Init section swiper slider)
        jQuery('.irantheme-gallery-social-post-swiper').each(
            function (index, element) {
                let gallerySocialItemsColumns = $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    gallerySocialItemsColumns,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );

                var swiperGallerySocial = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: gallerySocialItemsColumns,
                            spaceBetween: 15,
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    // swiperGallerySocialFixed() {
    //     let current = this;
    //     // Gallery social items (Init section swiper slider)
    //     jQuery('.irantheme-gallery-social-fixed-swiper').each(
    //         function (index, element) {
    //             var swiperGallerySocialFixed = new Swiper(element, {
    //                 modules: [Pagination, Thumbs],
    //                 slidesPerView: 1,
    //                 spaceBetween: 0,
    //                 pagination: {
    //                     el: $(element).find('.swiper-pagination')[0],
    //                     clickable: true,
    //                 },
    //                 lazy: {
    //                     enabled: true,
    //                     loadOnTransitionStart: true, // Start loading ASAP
    //                     loadPrevNext: true,
    //                 },
    //             });
    //         },
    //     );
    // }

    swiperBusinessBoxReviews() {
        let current = this;
        // Business box reviews (Init section swiper slider)
        jQuery('.irantheme-business-box-reviews-post-swiper').each(
            function (index, element) {
                let businessBoxReviewsPostColumns =
                    $(element).attr('data-columns');
                let breakpoints = current.generateBreakpointsForSwiper(
                    businessBoxReviewsPostColumns,
                    1,
                );
                var swiperBusinessBoxReviews = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: businessBoxReviewsPostColumns,
                    spaceBetween: 30,
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperBusinessViewpoints() {
        let current = this;
        // Business viewpoints post (Init section swiper slider)
        jQuery('.irantheme-business-viewpoints-post-swiper').each(
            function (index, element) {
                let businessViewpointsPostColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    businessViewpointsPostColumns,
                    1,
                );
                var swiperBusinessViewpoints = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: businessViewpointsPostColumns,
                    spaceBetween: 30,
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperWoocommerceSliderProduct() {
        let current = this;
        // Woocommerce categories post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-slider-product-swiper').each(
            function (index, element) {
                let woocommerceSliderProductPostColumns = 1;
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    woocommerceSliderProductPostColumns,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceCategoriesPost = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: woocommerceSliderProductPostColumns,
                            spaceBetween: 30,
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperWoocommerceBoxCategories() {
        let current = this;
        // Woocommerce categories post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-box-categories-post-swiper').each(
            function (index, element) {
                let woocommerceCategoriesPostColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    woocommerceCategoriesPostColumns,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceCategoriesPost = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: woocommerceCategoriesPostColumns,
                            spaceBetween: 30,
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperWoocommerceBoxBrands() {
        let current = this;
        // Woocommerce brands post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-box-brands-post-swiper').each(
            function (index, element) {
                let woocommerceBrandsPostColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    woocommerceBrandsPostColumns,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceBrandsPost = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: woocommerceBrandsPostColumns,
                            spaceBetween: 30,
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperWoocommerceCategories() {
        let current = this;
        // Woocommerce categories post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-categories-post-swiper').each(
            function (index, element) {
                let woocommerceCategoriesPostColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    woocommerceCategoriesPostColumns,
                    3,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceCategoriesPost = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: woocommerceCategoriesPostColumns,
                            spaceBetween: 30,
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperWoocommerceProducts() {
        let current = this;
        // Woocommerce products post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-products-post-swiper').each(
            function (index, element) {
                let colCount = $(element).attr('data-columns');
                let breakpoints =
                    current.generateBreakpointsForSwiper(colCount);
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceProductsPost = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: colCount,
                            spaceBetween: 30,
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperWoocommerceGridProducts() {
        let current = this;
        // Woocommerce products post (Init section swiper slider)
        jQuery('.irantheme-woocommerce-grid-products-swiper').each(
            function (index, element) {
                let colCount = $(element).attr('data-columns');
                let breakpoints = current.generateBreakpointsForSwiper(
                    colCount,
                    1,
                );
                // Check auto play status and stop
                let autoplayStatus = jQuery(element).data('slider-auto');
                let autoplayDelay = jQuery(element).data('slider-auto-delay');

                let autoplay = current.generateAutoplay(
                    autoplayStatus,
                    autoplayDelay,
                );
                var swiperWoocommerceGridProducts = new Swiper(
                    element,
                    Object.assign(
                        {
                            modules: [
                                Navigation,
                                Pagination,
                                Thumbs,
                                Autoplay,
                                FreeMode,
                            ],
                            slidesPerView: colCount,
                            spaceBetween: 30,
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            pagination: {
                                el: $(element).find('.swiper-pagination')[0],
                                clickable: true,
                            },
                            navigation: {
                                nextEl: $(element).find(
                                    '.swiper-button-next',
                                )[0],
                                prevEl: $(element).find(
                                    '.swiper-button-prev',
                                )[0],
                            },
                            lazy: {
                                enabled: true,
                                loadOnTransitionStart: true, // Start loading ASAP
                                loadPrevNext: true,
                            },
                            breakpoints,
                        },
                        autoplay,
                    ),
                );
            },
        );
    }

    swiperBusinessAuthorsPost() {
        let current = this;
        // Business authors post (Init section swiper slider)
        jQuery('.irantheme-business-authors-post-swiper').each(
            function (index, element) {
                let businessAuthorsPostColumns =
                    $(element).attr('data-columns');
                // Get breakpoints by columns count
                let breakpoints = current.generateBreakpointsForSwiper(
                    businessAuthorsPostColumns,
                    1,
                );
                var swiperBusinessAuthorsPost = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: businessAuthorsPostColumns,
                    spaceBetween: 30,
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    breakpoints,
                });
            },
        );
    }

    swiperMyAccountDashboardSlider() {
        // My account dashboard banner slider (Init swiper slider)
        jQuery('.irantheme-myaccount-dashboard-banner-slider').each(
            function (index, element) {
                var swiperMyaccountDashboardBannerSlider = new Swiper(element, {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    slidesPerView: 1,
                    spaceBetween: 10,
                    pagination: {
                        el: $(element).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    navigation: {
                        nextEl: $(element).find('.swiper-button-next')[0],
                        prevEl: $(element).find('.swiper-button-prev')[0],
                    },
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true, // Start loading ASAP
                        loadPrevNext: true,
                    },
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: true,
                    },
                });
            },
        );
    }

    swiperRelatedPosts() {
        let current = this;
        let breakpoints = current.generateBreakpointsForSwiper(3, 1);
        // Related post
        let relatedPost = new Swiper(
            '.post-single-advanced .related-post-slider',
            {
                modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
                slidesPerView: 1,
                spaceBetween: 30,
                slidesPerGroup: 1,
                loop: true,
                loopFillGroupWithBlank: true,
                lazy: {
                    enabled: true,
                    loadOnTransitionStart: true, // Start loading ASAP
                    loadPrevNext: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints,
            },
        );
    }

    // Gallery single overlay
    gallerySingleOverlay(dataGallery = 0) {
        this.gallerySingle = new Swiper('.swiper-gallery-overlay', {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            initialSlide: dataGallery,
        });
    }

    // Single gallery clickable init
    gallerySingleClickable() {
        // Open single gallery overlay
        $('.single-gallery.active img').on('click', function () {
            var data = parseInt($(this).data('gallery'));
            $('.single-gallery-overlay').fadeIn();
            if (data) this.gallerySingleOverlay(data);
            else this.gallerySingleOverlay();
        });
        // Close single gallery overlay with overlay clickable
        $('.single-gallery-overlay').on('click', function (e) {
            if (e.target == e.currentTarget) $(this).fadeOut();
        });
        // Close single gallery overlay with toggle button
        $('#close-gallery-overlay').on('click', function () {
            $('.single-gallery-overlay').fadeOut();
        });
    }

    // gallery master
    magnificationMediaGalleryItem() {
        let current = this;
        $('.irantheme-common-magnifiable-images').on(
            'click',
            '.irantheme-common-media-gallery-item',
            function (e) {
                e.preventDefault();
                // Get image thumb magnified holder
                let magnifiedHolder = $(this)
                    .parents('.irantheme-common-magnifiable-images')
                    .find('.irantheme-gallery-magnification-slider');
                // Get current slide number element
                let currentIndexSlide = $(magnifiedHolder)
                    .find('.irantheme-gallery-magnification-slider-topbar')
                    .children(
                        '.irantheme-gallery-magnification-slider-topbar-page',
                    )
                    .children(
                        '.irantheme-gallery-magnification-slider-topbar-page-current',
                    );
                // Get thumb selected item element
                let thumbSelected = $(this);
                let magnificationId = thumbSelected
                    .parents('.irantheme-common-magnifiable-images')
                    .find('.irantheme-gallery-magnification-slider')
                    .attr('id');
                // Get index of item selected
                let thumbSelectedIndex = $(thumbSelected).attr('data-item-id');
                // Get all video item element
                let videoItem = $(magnifiedHolder).find(
                    '.irantheme-gallery-magnification-slider-figure .irantheme-gallery-magnification-slider-figure-item video',
                );
                // Load all video element
                if (videoItem.length > 0) {
                    videoItem.each(function (index, element) {
                        $(element)[0].load();
                    });
                }
                currentIndexSlide.text(parseInt(thumbSelectedIndex) + 1);
                // Init slider
                current.magnificationSliderInit(
                    thumbSelectedIndex,
                    magnificationId,
                );
                // Show magnification holder
                magnifiedHolder.fadeIn('fast');
            },
        );
    }

    // Generate breakpoints for swiper
    generateBreakpointsForSwiper(colCount, colMobileCount = 2) {
        let settingObject = {};
        colCount = parseInt(colCount);
        colMobileCount = parseInt(colMobileCount);
        switch (colCount) {
            case 2:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: colCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: colCount,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: colCount,
                        },
                        991: {
                            slidesPerView: colCount,
                        },
                        1199: {
                            slidesPerView: colCount,
                        },
                        1376: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 3:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: colCount,
                        },
                        991: {
                            slidesPerView: colCount,
                        },
                        1199: {
                            slidesPerView: colCount,
                        },
                        1376: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 4:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: 3,
                        },
                        991: {
                            slidesPerView: colCount,
                        },
                        1199: {
                            slidesPerView: colCount,
                        },
                        1376: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 5:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: 3,
                        },
                        991: {
                            slidesPerView: 3,
                        },
                        1199: {
                            slidesPerView: 4,
                        },
                        1399: {
                            slidesPerView: 5,
                        },
                        1599: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 6:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: 3,
                        },
                        991: {
                            slidesPerView: 3,
                        },
                        1199: {
                            slidesPerView: 4,
                        },
                        1399: {
                            slidesPerView: 5,
                        },
                        1599: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 8:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 4,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: 4,
                        },
                        991: {
                            slidesPerView: 4,
                        },
                        1199: {
                            slidesPerView: 6,
                        },
                        1399: {
                            slidesPerView: colCount,
                        },
                        1599: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            case 12:
            case 13:
                settingObject = {
                    breakpoints: {
                        // when window width is >= 320px
                        1: {
                            slidesPerView: colMobileCount,
                            spaceBetween: 10,
                        },
                        // when window width is >= 350px
                        350: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        575: {
                            slidesPerView: 6,
                        },
                        // when window width is >= 640px
                        767: {
                            slidesPerView: 6,
                        },
                        991: {
                            slidesPerView: 6,
                        },
                        1199: {
                            slidesPerView: 8,
                        },
                        1399: {
                            slidesPerView: 8,
                        },
                        1599: {
                            slidesPerView: colCount,
                        },
                        1920: {
                            slidesPerView: colCount,
                        },
                    },
                };
                break;
            default:
                break;
        }
        return settingObject['breakpoints'];
    }

    // Generate autoplay object
    generateAutoplay(autoplayStatus, autoplayDelay) {
        if (autoplayStatus == 1) {
            return {
                autoplay: {
                    delay: parseInt(autoplayDelay, 10) || 5000,
                    disableOnInteraction: false,
                },
            };
        }
        return {};
    }

    // Generate link for download btn
    generateDownloadBtnUrl(magnificationId, slideIndex = 0) {
        // Get download btn element
        let downloadBtn = $('#' + magnificationId).find(
            '.irantheme-gallery-magnification-slider-topbar .irantheme-gallery-magnification-slider-topbar-action .irantheme-gallery-magnification-slider-action-download',
        );
        if (downloadBtn.length) {
            // Slide active holder
            let activeSlide;
            // Check slide index default value
            if (slideIndex != 0) {
                // if run when swiper init
                // Get all swiper slide
                activeSlide = $('#' + magnificationId).find(
                    '.irantheme-gallery-magnification-slider-figure .swiper-wrapper .irantheme-gallery-magnification-slider-figure-item',
                );
                // Loop on all swiper slide
                activeSlide.each(function (index, element) {
                    // Check slide index
                    if (
                        $(element).attr('data-slide-id') ==
                        parseInt(slideIndex) + 1
                    ) {
                        // Assign url of active slide to download btn
                        $(downloadBtn).attr(
                            'href',
                            $(element).attr('data-url'),
                        );
                    }
                });
                // else run when slide changing
            } else {
                // Get active swiper slide
                activeSlide = $('#' + magnificationId).find(
                    '.irantheme-gallery-magnification-slider-figure .swiper-wrapper .irantheme-gallery-magnification-slider-figure-item.swiper-slide-active',
                );
                // Assign url of active slide to download btn
                $(downloadBtn).attr('href', activeSlide.attr('data-url'));
            }
        }
    }

    // Generate link for share btn
    generateShareBtnUrl(magnificationId, slideIndex = 0) {
        // Get download btn element
        let shareBtn = $('#' + magnificationId).find(
            '.irantheme-gallery-magnification-slider-topbar .irantheme-gallery-magnification-slider-topbar-action .irantheme-gallery-magnification-slider-action-share-holder .irantheme-gallery-magnification-slider-share-dropdown',
        );
        if (shareBtn.length) {
            let pinterestShare = $(shareBtn)
                .children('.irantheme-share-pinterest')
                .children('a');
            let xShare = $(shareBtn)
                .children('.irantheme-share-x')
                .children('a');
            let telegramShare = $(shareBtn)
                .children('.irantheme-share-telegram')
                .children('a');
            let whatsappShare = $(shareBtn)
                .children('.irantheme-share-whatsapp')
                .children('a');
            // Slide active holder
            let activeSlide;
            // Check slide index default value
            if (slideIndex != 0) {
                // if run when swiper init
                // Get all swiper slide
                activeSlide = $('#' + magnificationId).find(
                    '.irantheme-gallery-magnification-slider-figure .swiper-wrapper .irantheme-gallery-magnification-slider-figure-item',
                );
                // Loop on all swiper slide
                activeSlide.each(function (index, element) {
                    // Check slide index
                    if (
                        $(element).attr('data-slide-id') ==
                        parseInt(slideIndex) + 1
                    ) {
                        // Assign url of active slide to share btn
                        $(pinterestShare).attr(
                            'href',
                            'http://pinterest.com/pin/create/button/?url=' +
                                $(element).attr('data-url'),
                        );
                        $(xShare).attr(
                            'href',
                            'https://twitter.com/intent/tweet?url=' +
                                $(element).attr('data-url'),
                        );
                        $(telegramShare).attr(
                            'href',
                            'https://t.me/share/url?url=' +
                                $(element).attr('data-url'),
                        );
                        $(whatsappShare).attr(
                            'href',
                            'https://api.whatsapp.com/send?text=' +
                                $(element).attr('data-url'),
                        );
                    }
                });
                // else run when slide changing
            } else {
                // Get active swiper slide
                activeSlide = $('#' + magnificationId).find(
                    '.irantheme-gallery-magnification-slider-figure .swiper-wrapper .irantheme-gallery-magnification-slider-figure-item.swiper-slide-active',
                );
                // Assign url of active slide to share btn
                $(pinterestShare).attr(
                    'href',
                    'http://pinterest.com/pin/create/button/?url=' +
                        $(activeSlide).attr('data-url'),
                );
                $(xShare).attr(
                    'href',
                    'https://twitter.com/intent/tweet?url=' +
                        $(activeSlide).attr('data-url'),
                );
                $(telegramShare).attr(
                    'href',
                    'https://t.me/share/url?url=' +
                        $(activeSlide).attr('data-url'),
                );
                $(whatsappShare).attr(
                    'href',
                    'https://api.whatsapp.com/send?text=' +
                        $(activeSlide).attr('data-url'),
                );
            }
        }
    }

    // Init gallery magnification swiper
    magnificationSliderInit(initialSlideData = 0, magnificationId) {
        let current = this;
        // Generate figure slider id
        let figureSlider =
            '#' +
            magnificationId +
            ' .irantheme-gallery-magnification-slider-figure.swiper';
        // Generate thumb slider id
        let thumbSlider =
            '#' +
            magnificationId +
            ' .irantheme-gallery-magnification-slider-thumb.swiper';
        // Gallery simple items (Init section swiper slider)
        var swiperGallerySimpleMagnificationThumb = new Swiper(thumbSlider, {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            slidesPerView: 2,
            spaceBetween: 1,
            centeredSlides: true,
            freeMode: true,
            watchSlidesProgress: true,
            initialSlide: initialSlideData,
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 3,
                    spaceBetween: 2,
                },
                // when window width is >= 480px
                575: {
                    slidesPerView: 5,
                    spaceBetween: 5,
                },
                // when window width is >= 640px
                767: {
                    slidesPerView: 7,
                    spaceBetween: 5,
                },
                991: {
                    slidesPerView: 10,
                    spaceBetween: 8,
                },
                1199: {
                    slidesPerView: 18,
                    spaceBetween: 8,
                },
            },
        });

        // Gallery simple items (Init section swiper slider)
        var swiperGallerySimpleMagnification = new Swiper(figureSlider, {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperGallerySimpleMagnificationThumb,
            },
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            initialSlide: initialSlideData,
            on: {
                afterInit: function () {
                    // Generate url for download btn
                    current.generateDownloadBtnUrl(
                        magnificationId,
                        initialSlideData,
                    );
                    // Generate url for share btn
                    current.generateShareBtnUrl(
                        magnificationId,
                        initialSlideData,
                    );
                },
            },
        });

        swiperGallerySimpleMagnification.on('slideChange', function () {
            // Get magnification holder
            let magnificationHolder = $(
                swiperGallerySimpleMagnification['wrapperEl'],
            )
                .parent()
                .parent();
            // Get current page number holder
            let pageHolder = magnificationHolder.find(
                '.irantheme-gallery-magnification-slider-topbar-page-current',
            );
            // Assign current slide number to page number holder
            pageHolder.text(
                parseInt(swiperGallerySimpleMagnification['activeIndex']) + 1,
            );
        });

        swiperGallerySimpleMagnification.on(
            'slideChangeTransitionEnd',
            function () {
                // Generate url for download btn
                current.generateDownloadBtnUrl(magnificationId);
                // Generate url for share btn
                current.generateShareBtnUrl(magnificationId);
            },
        );
    }

    woocommerceSingleProductGallery() {
        let current = this;
        if ($('.product-image-wrapper').length) {
            // Get gallery layout style
            let galleryLayout = $('.product-image-wrapper').data('layout');
            // Variable for save specific layout setting
            let settingGallery;
            // Check layout and set setting
            if (galleryLayout == 'thumb-grid') {
                settingGallery = {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    spaceBetween: false,
                    noSwiping: false,
                    allowSlidePrev: false,
                    allowSlideNext: false,
                };
            } else if (galleryLayout == 'thumb-slider') {
                settingGallery = {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    spaceBetween: 10,
                    slidesPerView: 6,
                };
            } else if (galleryLayout == 'thumb-slider-vertical') {
                settingGallery = {
                    modules: [
                        Navigation,
                        Pagination,
                        Thumbs,
                        Autoplay,
                        FreeMode,
                    ],
                    breakpoints: {
                        0: {
                            direction: 'horizontal',
                            slidesPerView: 4,
                            spaceBetween: 8,
                        },
                        768: {
                            direction: 'vertical',
                            spaceBetween: 8,
                            slidesPerView: 'auto',
                            autoHeight: true,
                        },
                    },
                    // rtl: true,
                };
            }
            current.thumbSwiper = new Swiper(
                '.product-image-thumb-slider',
                settingGallery,
            );
            current.heroSwiper = new Swiper('.product-image-hero.swiper', {
                modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                rtl: true,
                lazy: {
                    enabled: true,
                    loadOnTransitionStart: true, // Start loading ASAP
                    loadPrevNext: true,
                },
                thumbs: {
                    swiper: current.thumbSwiper,
                },
            });
        }
    }

    // Init gallery master magnification swiper
    magnificationSliderInit(initialSlideData = 0, magnificationId) {
        let current = this;
        // Generate figure slider id
        let figureSlider =
            '#' +
            magnificationId +
            ' .irantheme-gallery-magnification-slider-figure.swiper';
        // Generate thumb slider id
        let thumbSlider =
            '#' +
            magnificationId +
            ' .irantheme-gallery-magnification-slider-thumb.swiper';
        // Gallery simple items (Init section swiper slider)
        var swiperGallerySimpleMagnificationThumb = new Swiper(thumbSlider, {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            slidesPerView: 2,
            spaceBetween: 1,
            centeredSlides: true,
            freeMode: true,
            watchSlidesProgress: true,
            initialSlide: initialSlideData,
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 3,
                    spaceBetween: 2,
                },
                // when window width is >= 480px
                575: {
                    slidesPerView: 5,
                    spaceBetween: 5,
                },
                // when window width is >= 640px
                767: {
                    slidesPerView: 7,
                    spaceBetween: 5,
                },
                991: {
                    slidesPerView: 10,
                    spaceBetween: 8,
                },
                1199: {
                    slidesPerView: 18,
                    spaceBetween: 8,
                },
            },
        });

        // Gallery simple items (Init section swiper slider)
        var swiperGallerySimpleMagnification = new Swiper(figureSlider, {
            modules: [Navigation, Pagination, Thumbs, Autoplay, FreeMode],
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperGallerySimpleMagnificationThumb,
            },
            lazy: {
                enabled: true,
                loadOnTransitionStart: true, // Start loading ASAP
                loadPrevNext: true,
            },
            initialSlide: initialSlideData,
            on: {
                afterInit: function () {
                    // Generate url for download btn
                    current.generateDownloadBtnUrl(
                        magnificationId,
                        initialSlideData,
                    );
                    // Generate url for share btn
                    current.generateShareBtnUrl(
                        magnificationId,
                        initialSlideData,
                    );
                },
            },
        });

        swiperGallerySimpleMagnification.on('slideChange', function () {
            // Get magnification holder
            let magnificationHolder = $(
                swiperGallerySimpleMagnification['wrapperEl'],
            )
                .parent()
                .parent();
            // Get current page number holder
            let pageHolder = magnificationHolder.find(
                '.irantheme-gallery-magnification-slider-topbar-page-current',
            );
            // Assign current slide number to page number holder
            pageHolder.text(
                parseInt(swiperGallerySimpleMagnification['activeIndex']) + 1,
            );
        });

        swiperGallerySimpleMagnification.on(
            'slideChangeTransitionEnd',
            function () {
                // Generate url for download btn
                current.generateDownloadBtnUrl(magnificationId);
                // Generate url for share btn
                current.generateShareBtnUrl(magnificationId);
            },
        );
    }

    // ReInit function for fix direction of thumb slider
    woocommerceSingleProductGalleryReInit() {
        this.thumbSwiper.destroy(true, true);
        this.heroSwiper.destroy(true, true);
        this.woocommerceSingleProductGallery();
    }
}

export default SwiperJs;
